import { CliError } from "@types";

import { Highlight } from "@pages/editor/types/highlight";

import { makeHighlight } from "./makeHighlight";

export const makeErrorHighlight = (
  error: CliError,
  type?: string
): Highlight => {
  const span = error.spans?.[0];
  const start = span?.start ?? { line: 1, col: 0 };
  return {
    ...makeHighlight(start, span?.end),
    key: `${error.type}-${error.rule_id}-${start.line}-${start.col}`,
    isError: true,
    type: type ?? "unknown",
    group: error.type,
    message: error.message,
    configLocation: span,
  };
};
